import Fuse from 'fuse.js'
import { StoreDetails, Query } from '@scentregroup/shared/types/browse-stores'
import { RetailCategory } from '../stores/types'

export const categoryList = (
  retailCategories: RetailCategory[]
): RetailCategory[] => retailCategories.filter(category => category.level === 1)

export const subCategoryList = (
  retailCategories: RetailCategory[],
  category: string
): RetailCategory[] => {
  const categoryObj = retailCategories.filter(c => c.title === category)[0]
  return retailCategories.filter(item => item.parentId === categoryObj.id)
}

export const storesAcceptGiftCard = (
  stores: StoreDetails[]
): StoreDetails[] => {
  const paymentMethods = (
    store: StoreDetails
  ): StoreDetails['paymentMethods'] =>
    store.paymentMethods.length > 0
      ? store.paymentMethods
      : store.retailer?.paymentMethods || []
  return stores.filter(
    (store: StoreDetails) =>
      paymentMethods(store).indexOf('Westfield Giftcard') > -1
  )
}

export const storesMatchSearch = (
  stores: StoreDetails[],
  searchTerm: string
): StoreDetails[] => {
  const options = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    keys: ['title'],
  }

  return new Fuse(stores, options).search(searchTerm)
}

export const filterStores = (
  stores: StoreDetails[],
  query: Query
): StoreDetails[] => {
  let filteredStores: StoreDetails[] = stores

  const { searchTerm, giftCardAccepted, sortBy } = query

  if (searchTerm) {
    filteredStores = storesMatchSearch(filteredStores, searchTerm)
  }

  if (giftCardAccepted) {
    filteredStores = storesAcceptGiftCard(filteredStores)
  }

  if (sortBy === 'desc') {
    filteredStores = filteredStores.sort((a, b) =>
      b.title.toLowerCase().localeCompare(a.title.toLowerCase())
    )
  }

  return filteredStores
}
